module.exports = __webpack_public_path__ + "img/logo.b5e82050.png";